import { Node } from "../../../Utils/Collections/Node";
import { MapCell as PredefinedMapCell, eTileType } from "../Game Map/MapCell";
import { Gameplay, eBatchGroup } from "../../Gameplay";
import { ViewCellMapCell } from "../View/ViewCellMapCell";
import { Player } from "../Player/Player";



/**
 * Dlazdice, pomoci ktere se vykresluje zem herniho sveta
 */
export abstract class TileBase {
    /**
     * Velikost dlazdice v jednotkach sceny
     */
    static readonly SIZE = 1;

    protected static readonly FLAG_GROUND = 0x0001;
    protected static readonly FLAG_HANDLE_COLLISION = 0x0002;

    protected _flags: number;

    /**
     * pc.Entity pro vykresleni dlazdice ve scene
     */
    protected _entity: pc.Entity;

    /**
     * (RO) Bunka, ktere dlazdice patri
     */
    get cell(): ViewCellMapCell { return this._cell; }
    protected _cell: ViewCellMapCell;

    /**
     * Uzel v seznamu dlazdic, u kterych je potreba volat update()
     */
    actTileListNode: Node<TileBase>;

    /**
     * (RO) Typ dlazdice
     */
    get type(): eTileType { return this._type; }
    protected _type: eTileType;

    /**
     * (RO) Verze dlazdice
     */
    get version(): number { return this._version; }
    protected _version: number;

    /**
     * (RO) True, pokud dlazdice tvori zem, po ktere se muze hrac pohybovat
     */
    get ground(): boolean { return (this._flags & TileBase.FLAG_GROUND) != 0; }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(type: eTileType) {
        // Typ dlazdice
        this._type = type;
        this._version = 0;

        // Entita
        this._entity = new pc.Entity();
        this._entity.addComponent(pc.eCompomentType.model, {
            type: pc.eModelType.asset,
            batchGroupId: Gameplay.BATCH_GROUP_ID[eBatchGroup.solid_0],
            castShadows: false,
            castShadowsLightmap: false,
            receiveShadows: false,
            lightmapped: false,
        });

        this._entity.enabled = false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(cell: ViewCellMapCell, cellData: PredefinedMapCell): void {
        this._cell = cell;
        this._type = cellData.tileType;
        this._version = cellData.tileVersion;
        this._flags = TileBase.FLAG_GROUND | TileBase.FLAG_HANDLE_COLLISION;

        // Nastavit entitu
        this._entity.setLocalPosition(cell.cellId * TileBase.SIZE + TileBase.SIZE / 2, 0, 0);
        this._entity.enabled = true;

        let rowGraphNode = cell.row.graphNode;

        if (this._entity.parent != rowGraphNode)
            this._entity.reparent(rowGraphNode);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    release(): void {
        this._entity.enabled = false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean { return true; }

    //-------------------------------------------------------------------------
    /**
     * Zpracovat kolizi s hracem
     */
    //-------------------------------------------------------------------------
    handleCollision(player: Player): boolean { return false; }
}